import Repository from "../../repository";

export default {
    GetList: (payload) => Repository.post(`/api/PostMobilePublish/GetList`, payload),
    GetGroupDetail: (payload) => Repository.post(`/api/PostMobilePublish/GetGroupDetail`, payload),
    GetDetail: (payload) => Repository.post(`/api/PostMobilePublish/GetDetail`, payload),
}
